module.exports = __webpack_public_path__ + "assets/img/beilage02-26.e235a003.jpg";